import { render } from "./AlphanumericFormat.vue?vue&type=template&id=35128370"
import script from "./AlphanumericFormat.vue?vue&type=script&lang=js"
export * from "./AlphanumericFormat.vue?vue&type=script&lang=js"

import exportComponent from "/Users/akhenry/Code/openmct-clean/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__